import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Dashboard } from '../../../domain/models/dashboard';

@Component({
  selector: 'app-delete-dashboard',
  templateUrl: './delete-dashboard.component.html',
  styleUrls: ['./delete-dashboard.component.scss']
})
export class DeleteDashboardComponent implements OnInit {
  @Input() dashboardId: string;
  @Input() dashboardName: string;
  @Output() onConfirmDelete = new EventEmitter<string>();
  @Output() onCancelDelete = new EventEmitter<void>();

  private formLocked: boolean;

  constructor() { }

  ngOnInit() {
    this.formLocked = false;
  }

  confirmDelete(): void {
    if (!this.formLocked) {
      this.formLocked = true;
      this.onConfirmDelete.emit(this.dashboardId);
    }
  }

  cancelDelete(): void {
    this.onCancelDelete.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard-overview/components/delete-dashboard/delete-dashboard.component.ts